import FingerprintJS from '@fingerprintjs/fingerprintjs'

let fpPromise = null
let cachedVisitorId = null

export const initFingerprint = () => {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load()
  }
}

export const getFingerprint = async () => {
  try {
    if (cachedVisitorId) return cachedVisitorId

    if (!fpPromise) initFingerprint()

    const fp = await fpPromise
    const result = await fp.get()
    cachedVisitorId = result.visitorId
    return cachedVisitorId
  } catch (error) {
    console.error('Error getting fingerprint', error)
    return null
  }
}
